import BackgroundMusicDialog from "./BackgroundMusicDialog";
import TabTitle from "../TabTitle";
import MusicTrimAndFadeControl from "./MusicTrimAndFadeControl";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import MusicVolumeControl from "./MusicVolumeControl";
import BeatSyncDialog from "./BeatSyncDialog/BeatSyncDialog";
import { Button } from "@/lib/components/Button/Button";
import { useState } from "react";
import { Dot } from "@/lib/components/Badge";
import { useBeatSyncsQuery } from "@/lib/queries/beat-sync-queries";
import { useIsFeatureEnabled } from "@/lib/feature-flags";
import { IconWaveSine } from "@tabler/icons-react";
import { useIsSyncedToBeat } from "../useIsSyncedToBeat";

export default function MusicTab() {
  const compositionJson = useEditorStore(
    (state) => state.video?.compositionJson,
  );
  const backgroundMusic = compositionJson?.backgroundMusic;
  const teamExternalId = useEditorStore((state) => state.teamExternalId);
  const canManageBeatSync = useIsFeatureEnabled();
  const [isBeatSyncOpen, setIsBeatSyncOpen] = useState(false);

  const { data: beatSyncs = [] } = useBeatSyncsQuery(
    teamExternalId,
    backgroundMusic?.externalId,
  );

  const isSyncedToBeat = useIsSyncedToBeat(beatSyncs);

  const supportsBeatSync = beatSyncs.length > 0 || canManageBeatSync;

  return (
    <div className="relative flex h-full flex-col">
      <div className="grow overflow-y-auto pb-8">
        <TabTitle
          title="Music"
          subtitle="Add background music to your video."
        />
        <div className="px-6">
          <BackgroundMusicDialog />
          {backgroundMusic !== undefined && (
            <>
              <MusicVolumeControl />
              {supportsBeatSync ? (
                <div className="mt-8 w-full">
                  <div className="input-label">Beat sync</div>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setIsBeatSyncOpen(true)}
                    icon={<IconWaveSine strokeWidth={2.5} size={18} />}
                    iconPosition="leading"
                    className="pr-4 pl-4.5"
                  >
                    <span className="flex items-center gap-2">
                      {isSyncedToBeat
                        ? "Video synced to beat"
                        : "Sync video to beat"}
                      {isSyncedToBeat ? <Dot /> : null}
                    </span>
                  </Button>
                </div>
              ) : null}
            </>
          )}
        </div>
      </div>
      {backgroundMusic !== undefined && (
        <div className="flex min-h-24 w-full shrink-0 items-center border-t border-grey-200 px-6 py-4">
          <MusicTrimAndFadeControl />
        </div>
      )}
      {backgroundMusic?.externalId !== undefined && (
        <BeatSyncDialog
          open={isBeatSyncOpen}
          onOpenChange={setIsBeatSyncOpen}
          trackExternalId={backgroundMusic.externalId}
          beatSyncs={beatSyncs}
        />
      )}
    </div>
  );
}
